/**
 *    App - Toggle content
 */

(function ($) {
  Drupal.behaviors.appToggleContent = {
    attach() {
      /**
       * Mobile toggle
       */
      $('.vb-mobile-toggle__button').on('click', function (e) {
        e.preventDefault();
        const $button = $(this);
        const $container = $button.closest('.vb-mobile-toggle');
        const $target = $container.find('.vb-mobile-toggle__target');

        // a11y: toggle attribute
        $button.attr('aria-expanded', 'aria-expanded' === 'false' ? 'true' : 'false');

        // close button
        $button.slideToggle(500);

        // open target
        $target.slideToggle(500);
      });
    },
  };
}(jQuery));
